import { LOCALES, type Locale } from '../i18n/index';
import type { LegalDoc } from '../content/legal';

/**
 * The locales a legal document (оферта / privacy) is really WRITTEN in, in
 * `LOCALES` order: Russian always, Uzbek when the doc carries an Uzbek body.
 * There is no Kazakh body — `LegalDoc` has none — so on KZ this is `['ru']`.
 *
 * kaztender.com audit, 2026-10-17: `/kk/offer` and `/kk/privacy` showed the
 * Russian text with a self-canonical and an hreflang="kk" alternate, i.e. told
 * search engines a Kazakh page exists. The page and the sitemap now describe
 * a borrowed body the way the guide pages do (`guideArticleLocales`): canonical
 * and hreflang name only these locales. On UZ both documents carry `uz`, so
 * the list is every locale and nothing changes there.
 *
 * Its own module (not `legal-page.tsx`) because `scripts/prerender.ts` needs it
 * for the sitemap and must not pull a React component into the build script.
 */
export function legalDocLocales(doc: LegalDoc): Locale[] {
  return LOCALES.filter((l) => l === 'ru' || (l === 'uz' && doc.uz != null));
}
